import format from 'date-fns/format'
import { getLocalModifiedDate, getModifiedDate } from '../funcs/helperFuncs'

const ErrorHandler = ({error}) => {
    return (
        <td></td>
    )
  }

export default function Dates ({d, isApproval}) {
    try {
        var newD
        if (isApproval) {
            newD = getLocalModifiedDate(d)
        } else {
            newD = getModifiedDate(d)
        }
        return <td>{format(Date.parse(newD), 'MM/dd/yy')}</td>
    } catch (error) {
        return <ErrorHandler error={error} />
    }
  }


  